import { Box, Typography } from '@mui/material';
import CotacaoDetalheModal from './Modals/CotacaoDetalheModal';
import moment from 'moment';

const renderStatus = (value) => {
  const color =
    value === 'CONCLUIDO'
      ? '#7FFF7F'
      : value === 'PENDENTE'
      ? '#FFFF7F'
      : value === 'CANCELADO'
      ? '#FF7F7F'
      : 'transparent';

  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: color,
        borderRadius: '50px',
      }}
    >
      <span>{value}</span>
    </div>
  );
};

const getRequisiçõesColumnOverrides = (openDialog) => [
  { field: 'status', renderCell: ({ value }) => renderStatus(value) },
  {
    field: 'dtemissao',
    valueGetter: ({ value }) => value && moment(value).format('DD/MM/YYYY'),
  },
  {
    field: 'preco',
    valueGetter: ({ value }) =>
      value?.toLocaleString('pt-br', {
        style: 'currency',
        currency: 'BRL',
      }),
  },
  {
    field: 'historico',
    renderCell: ({ row }) => {
      const arr = row?.historico || [];

      if (row.status === 'CONCLUIDO') {
        const pedidos = arr?.filter((f) => f?.especie_id === 4);

        return (
          <Box my={1}>
            {Boolean(pedidos?.length) && (
              <Typography fontWeight="bold" variant="body2">
                Pedidos
              </Typography>
            )}
            {pedidos?.map((pedido, i) => (
              <Typography key={i?.toString()} variant="caption">
                • {pedido?.texto}
              </Typography>
            ))}
          </Box>
        );
      }

      if (row?.status === 'PENDENTE') {
        const cotacoes = arr?.filter((f) => f?.especie_id === 3);
        const compras = arr?.filter((f) => ![3, 4]?.includes(f?.especie_id));

        return (
          <Box my={1}>
            {Boolean(compras?.length) && (
              <Typography fontWeight="bold" variant="body2">
                Últimas Compras
              </Typography>
            )}
            {compras?.map((cp, i) => (
              <Box key={`${i}`}>
                <Typography variant="caption">• {cp?.texto}</Typography>
              </Box>
            ))}
            {Boolean(cotacoes?.length) && (
              <Typography
                fontWeight="bold"
                variant="body2"
                mt={Boolean(compras?.length) ? 2 : 0}
              >
                Cotações Enviadas
              </Typography>
            )}
            {cotacoes?.map((ct, i) => (
              <Box key={`${i}`}>
                <Typography
                  variant="caption"
                  onClick={() =>
                    openDialog(
                      <CotacaoDetalheModal
                        requisicao_id={row?.documento_id}
                        documento_id={ct?.id}
                        item_id={row?.id}
                      />,
                      'Detalhes da Cotação'
                    )
                  }
                  sx={{
                    cursor: 'pointer',
                    '&:hover': { textDecoration: 'underline' },
                  }}
                >
                  • {ct?.texto}
                </Typography>
              </Box>
            ))}
          </Box>
        );
      }
      return null;
    },
  },
];

export default getRequisiçõesColumnOverrides;
